export const cronLogsConstants = {
    GET_CRONLOGS_DATA_REQUEST: 'GET_CRONLOGS_DATA_REQUEST',
    GET_CRONLOGS_DATA_SUCCESS: 'GET_CRONLOGS_DATA_SUCCESS',
    GET_CRONLOGS_DATA_FAILURE: 'GET_CRONLOGS_DATA_FAILURE',
}